import { IFlatTourBooking } from '../../types/flatTourBooking';
import { TApplicationState } from '../../types/redux';

export function getFlatTourSchedule(state: TApplicationState): IFlatTourBooking | null {
  return state.flatTourBookingState.flatTourBooking;
}
